import { WithAuthorization } from "../../context";
import { Page } from "../../components/Page";
import { Card, Heading } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

function SupplierResources() {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierResources"
  });

  return (
    <Page>
      <Card height={"calc(100vh - 120px)"} alignItems={"center"} justifyContent={"center"}>
        <Heading size={"2xl"}>
          {t("noContentAvailableYet")}
        </Heading>
      </Card>
    </Page>
  )
}

export default WithAuthorization(SupplierResources);